import {Component} from '@angular/core';
import {LocalStorageService} from './shared/services/local-storage.service';
import {TranslocoService} from '@jsverse/transloco';
import {NavigationService} from './shared/services/navigation.service';
import {ComuneService} from "./shared/services/comune.service";
import {FuseConfirmationService} from "../@fuse/services/confirmation";
import {UtentiService} from "../api-clients/generated/services";
import {Router} from "@angular/router";
import {PathEnum} from "./app.routing";
import {finalize} from "rxjs";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(private localStorageService: LocalStorageService,
                private comuneService: ComuneService,
                private navigationService: NavigationService,
                private fuseConfirmationService: FuseConfirmationService,
                private userControllerService: UtentiService,
                private router: Router,
                private translocoService: TranslocoService) {
        this.translocoService.setActiveLang(this.localStorageService.getActiveLang() || 'it')
        this.navigationService.subNav();
        if (!comuneService?.comuni?.length && this.localStorageService.getAccessToken()) {
            if(this.localStorageService.isOpScuola()){
                this.router.navigate([PathEnum.SCUOLE]);
            } else {
                this.router.navigate([PathEnum.HOME]);
            }
            setTimeout(() => this.getComuni(), 200)
        }
    }


    private getComuni() {
        this.fuseConfirmationService.errorGetData(this.translocoService, () => this.goToLogin(), () => this.getData(),'dialog.cancel');
    }

    private getData() {
        this.fuseConfirmationService.showLoader();
        this.userControllerService.getComuniUtente()
            .pipe(finalize(() => this.fuseConfirmationService.hideLoader()))
            .subscribe({
                next: (value) => {
                    this.comuneService.setListaComuni(value);
                    this.comuneService.setFirstComune(value);

                }, error: err => {
                    this.getComuni();
                }
            })
    }

    private goToLogin() {
        this.localStorageService.cleanToken();
        this.router.navigate([PathEnum.SIGN_IN]);
    }
}
